<template>
  <CardLoaderSmall v-if="isLoading" class="col-span-full flex-1 flex-col" />
  <box v-else class="col-span-full">
    <SectionHeader
      title="Porttelefon"
      :editable="canEdit"
      :editing="editable"
      :disabled="editDisabled"
      @edit="$emit('edit')"
      @cancel="cancel"
    />
    <h4 class="text-t6 mb-4">Uppgifter i porttelefon</h4>

    <div class="w-1/2">
    <SelectField
      :class="{ 'mb-8': selectedContract }"
      v-if="contractsData && contractsData.length > 1"
      id="contractNumber"
      label="Kontrakt"
      placeholder=""
      :floatingLabel="true"
      :options="contractsData"
      v-model="selectedContract"
    />
    </div>


    <div v-if="selectedContract">
      <div v-for="(entry, index) in localEntries" :key="index" class="space-y-2" :class="!editable && index != localEntries.length-1 ? 'pb-6' : 'pb-4'">
        <div class="align-center flex w-full md:w-1/2 flex-row items-center">
          <h3 class="text-b2 text-gray-900 font-bold uppercase tracking-wider font-neue-kabel font-thick text-[14px]" :class="index==0 && editable ? 'mb-2' : ''">Person {{ index + 1 }}</h3>
          <Button v-if="index > 0 && editable" variant="danger" class="ml-auto" @click="removeEntry(index)">
            Ta bort
            <template #icon-after><IconTrashCan /></template>
          </Button>
        </div>

        <div class="flex w-full md:w-1/2 flex-1 flex-col space-y-2" v-if="editable">
          <Input
            :id="`intercom-name-${index}`"
            label="Namn på porttelefon"
            v-model="entry.name"
            type="text"
            placeholder="Namn"
            :floatingLabel="true"
          />
          <Input
            :id="`intercom-number-${index}`"
            label="Telefonnummer på porttelefon"
            v-model="entry.number"
            type="tel"
            placeholder="0701234567"
            :floatingLabel="true"
          />
        </div>
        <div class="flex w-full md:w-1/2 flex-1 flex-col space-y-2" v-else>
          <p class="text-[18px]">{{entry.name}}</p>
          <p class="text-[18px]">{{entry.number}}</p>
        </div>
      </div>

      <Button variant="text" class="mt-4" @click="addEntry" v-if="editable">
        <template #icon-before><IconPlus /></template>
        Lägg till en person i porttelefonen
      </Button>

      <div class="flex items-end justify-start" v-if="editable">
        <Button
          variant="primary"
          size="large"
          class="mt-6"
          :disabled="JSON.stringify(localEntries) === JSON.stringify(savedEntries) || !isFormValid"
          @click="handleSave"
        >
          Spara ändringar
        </Button>
      </div>
    </div>

    <div v-if="!selectedContract && editable" class="flex items-end justify-start">
      <Button variant="primary" class="mt-6" :disabled="true" @click="handleSave" size="large">
        Spara ändringar
      </Button>
    </div>
  </box>
</template>

<script>
import Box from '@/components/ui/box';
import Input from '@/components/ui/form/input';
import Button from '@/components/ui/button';
import IconPlus from '@/components/icons/IconPlus';
import IconTrashCan from '@/components/icons/IconTrashCan';
import { mapGetters } from 'vuex';
import CardLoaderSmall from '@/components/loader/CardLoaderSmall';
import SelectField from '@/components/ui/form/select';
import SectionHeader from '@/components/profile/section-header';

export default {
  name: 'IntercomSection',
  components: {
    SelectField,
    Box,
    Input,
    Button,
    IconPlus,
    IconTrashCan,
    CardLoaderSmall,
    SectionHeader,
  },
  props: {
    // Om sektionen är i redigeringsläge
    editable: {
      type: Boolean,
      default: true,
    },
    // Om användaren får redigera (visar "Ändra")
    canEdit: {
      type: Boolean,
      default: true,
    },
    // En annan sektion redigeras
    editDisabled: {
      type: Boolean,
      default: false,
    },
    contractNumber: {
      type: Array,
      required: true,
    },
  },
  emits: ['edit', 'cancel', 'save'],
  data() {
    return {
      isLoading: true,
      localEntries: [],
      savedEntries: [],
      hasChanges: false,
      selectedContract: null,
      contractsData: null,
      // testAlwaysLoading: true,
    };
  },
  computed: {
    ...mapGetters(['getNamesOnDoorByContractNumber']),
    isFormValid() {
      return this.localEntries.every(
        (entry) => entry.name.trim() !== '' && entry.number.trim() !== '',
      );
    },
  },
  mounted() {
    if (!this.testAlwaysLoading) {
      new Promise((resolve) => setTimeout(resolve, 500)).then(() => {
        if (this.contractNumber.length == 1) this.selectedContract = this.contractNumber[0];
        else this.contractsData = this.transformContracts(this.contractNumber);
        this.isLoading = false;
      });
    }
  },
  watch: {
    selectedContract: {
      deep: true,
      handler(contract) {
        if (!contract || !contract.contractNumber) return;

        return this.$store.cache
          .dispatch('fetchNamesOnDoorByContractNumber', contract.contractNumber)
          .then((result) => {
            this.localEntries = JSON.parse(JSON.stringify(result.intercomes));
            this.savedEntries = JSON.parse(JSON.stringify(result.intercomes));
            if (this.localEntries.length == 0) this.addEntry();
          })
          .finally(() => {
            this.showLoader = false;
          });
      },
    },
  },
  methods: {
    addEntry() {
      this.localEntries.push({ name: '', number: '' });
    },
    removeEntry(index) {
      if (index >= 0) this.localEntries.splice(index, 1);
    },

    /*    handleSave() {

      const storeData = this.getNamesOnDoorByContractNumber(this.selectedContract.contractNumber);
      return this.$store
        .dispatch('saveNamesOnDoor', {
          "NameOnDoor": storeData?.localDoorName,
          "intercomes": this.localEntries,
          "ContractNumber": this.selectedContract.contractNumber
        })
        .then((result) => {
          this.initialValue = this.localDoorName;
        })
        .finally(() => {
          this.showLoader = false;
        });
    },*/
    handleSave() {
      const storeData = this.getNamesOnDoorByContractNumber(this.selectedContract.contractNumber);
      this.savedEntries = JSON.parse(JSON.stringify(this.localEntries));
      this.hasChanges = false;
      this.$emit('save', [
        this.localEntries,
        this.selectedContract.contractNumber,
        storeData?.NameOnDoor,
      ]);
    },

    cancel() {
      this.localEntries = JSON.parse(JSON.stringify(this.savedEntries));
      if (this.localEntries.length == 0) this.addEntry();
      this.$emit('cancel');
    },

    transformContracts(contracts) {
      return contracts.map((contract) => ({
        ...contract,
        label: contract.rentalObject?.address1 || '', // Move address1 to the root level
        rentalObject: { ...contract.rentalObject }, // Keep rentalObject intact
        value: { ...contract },
      }));
    },
  },
};
</script>
